
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/container',['Vue', 'vue!../reusableComponents/loader', 'vue!./venueDetails', 'vue!./stayDetails', 'vue!./dailyRateSplit', 'vue!./personalDetails', 'vue!./shareWith/container', 'vue!./eRegOptions', 'vue!./venuePolicy', 'vue!./companyPolicy', 'vue!./signatureContainer', 'vue!./companyPolicyHeader', 'vue!./venuePolicyHeader', 'vue!./alertsContainer', 'vue!./onFileCreditCard', 'vue!./noValidFolio'], function (Vue, loader, venueDetails, stayDetails, dailyRateSplit, personalDetails, shareWith, eRegOptions, venuePolicy, companyPolicy, signatureContainer, companyPolicyHeader, venuePolicyHeader, alertsContainer, onFileCreditCard, noValidFolio) {
        return {
            name: 'eRegContainer',
            template: template,
            components: {
                loader: loader,
                'alerts-container': alertsContainer,
                'company-policy-header': companyPolicyHeader,
                'venue-policy-header': venuePolicyHeader,
                'venue-details': venueDetails,
                'stay-details': stayDetails,
                'daily-rate-split': dailyRateSplit,
                'personal-details': personalDetails,
                'share-with': shareWith,
                'e-reg-options': eRegOptions,
                'venue-policy': venuePolicy,
                'company-policy': companyPolicy,
                'signature-container': signatureContainer,
                'onfile-credit-card': onFileCreditCard,
                'no-valid-folio': noValidFolio
            },
            data: function () {
                return {
                    isMetPrerequisite: false,
                    loggedInWithOtherUser: false,
                    errorMessage: ''
                }
            },
            methods: {
                onClickChild: function (value) {
                    var vm = this
                    vm.$store.dispatch('pmsCheckin/logoutOtherUser').then(function () {
                        vm.loggedInWithOtherUser = false
                    })
                },
                renderAuthFailMessage: function () {
                    var vm = this
                    vm.errorMessage = this.localization.roomReservation.pmsCheckIn.errors.leadingHeader.couldntFindFolio + ' #'+ vm.pmsFolioId + ' - ' +vm.lastName
                },
                handleUserAuthentication: function () {
                    var vm = this
                    if(!vm.customization.login.alternativeLogin){
                        app.dispatcher.replace('profile','login',['next','summary','eReg',vm.venueName,vm.pmsFolioId,vm.lastName]);
                        return;
                    }
                    params = {
                        folioId: vm.pmsFolioId,
                        lastname: vm.lastName
                    }
                    vm.$store.dispatch('pmsCheckin/authenticatefolio', params).then(function () {
                        vm.$store.dispatch('pmsCheckin/updateNavbar')
                        vm.checkPmsFolioValid();

                    }, function (error) {
                        vm.renderAuthFailMessage()
                    })
                },
                checkPmsFolioValid: function () {
                    var vm = this;
                    if(!vm.pmsFolioId || !vm.lastName) {
                        vm.errorMessage = vm.localization.roomReservation.pmsCheckIn.errors.invalidUrl
                        return
                    }
                    if (app.data.userLoggedIn) {
                        var fetchCustomerPMSBookingsRes = app.models.userModel.dataModel.fetchCustomerPMSBookings.data && app.models.userModel.dataModel.fetchCustomerPMSBookings.data[app.models.userModel.makeStandardName(app.models.userModel.dataModel.fetchCustomerPMSBookings,{ CustomerId: app.data.CustomerId, CustomerGUID: app.data.CustomerGUID })];
                        var foundBooking = fetchCustomerPMSBookingsRes.PMSBooking && fetchCustomerPMSBookingsRes.PMSBooking.find(function (booking) {
                            return booking.PMSFolioId == vm.pmsFolioId
                        })
                        console.log('ozan', foundBooking)
                        if (!foundBooking) {
                            vm.loggedInWithOtherUser = true
                            return;
                        } else {
                            switch(foundBooking.PreCheckInStatus){
                                case 'N':
                                    vm.errorMessage = app.localization.roomReservation.pmsCheckIn.errors.preCheckInUnavailable
                                    return
                                case 'C':
                                    vm.errorMessage =   app.localization.roomReservation.pmsCheckIn.errors.preCheckInAlreadyCompleted
                                    return
                            }
                           
                            switch(foundBooking.BookStatus){
                                case 'CANCEL':
                                    vm.errorMessage = app.localization.roomReservation.pmsCheckIn.errors.bookingAlreadyCancelled
                                    return
                                case 'INHOUSE':
                                    vm.errorMessage = app.localization.roomReservation.pmsCheckIn.errors.bookingAlreadyInhouse
                                    return
                                case 'CHKOUT':
                                    vm.errorMessage = app.localization.roomReservation.pmsCheckIn.errors.bookingAlreadyCompleted
                                    return
                            }
                        }
                        vm.isMetPrerequisite = true
                    }
                }
            },
            computed: {
                showLoader: function () {
                    return this.$store.state.pmsCheckin.showLoader.length > 0;
                },
                pmsFolioId: function () {
                    return this.$globalParameters.pmsFolioId
                },
                lastName: function () {
                    return this.$globalParameters.lastName
                },
                venueName: function(){
                    return this.$globalParameters.venueName
                }
            },
            beforeMount: function () {
                var vm = this
                //  debugger
                if (app.data.userLoggedIn) {
                    vm.checkPmsFolioValid();
                } else vm.handleUserAuthentication()
            },
        }
    })
})('<div class="relative"> <div v-if="isMetPrerequisite"> <loader :showLoader="showLoader" :loadingMessage="localization.roomReservation.pmsCheckIn.loadingText" /> <alerts-container id="alertsContainer" /> <venue-details id="venueDetails" /> <company-policy-header id="companyPolicyHeader" /> <venue-policy-header id="venuePolicyHeader" /> <stay-details id="stayDetails" /> <daily-rate-split id="dailyRateSplit" /> <personal-details :showBasicFields="true" id="personalDetails" /> <onfile-credit-card id="onFileCreditCard" /> <share-with id="shareWith" /> <e-reg-options id="eRegOptions" /> <venue-policy id="venuePolicy" /> <company-policy id="companyPolicy" /> <signature-container id="signatureContainer" /> </div> <div v-else> <no-valid-folio :errorMessage="errorMessage" :loggedInWithOtherUser="loggedInWithOtherUser" @relogin="onClickChild" id="noValidFolio" /> </div> </div>');
